import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API, { partnerApiUrl as PartnerQK } from './api';
import { ResponseType } from 'src/constants/data';

export const useGetPartners = (data: { tagId?: string }) => {
  return useQuery({
    queryKey: [PartnerQK, ResponseType.List, data],
    queryFn: () => API.getPartners(data),
    placeholderData: keepPreviousData
  });
};

export const useGetPartnerTags = () => {
  return useQuery({
    queryKey: [PartnerQK, ResponseType.List],
    queryFn: () => API.getTags(),
    placeholderData: keepPreviousData
  });
};
